import React from "react";
import Rs from "../../utils/images/rsvp-1920.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import styled from "styled-components";

const Layout = styled.div`
  text-align: center;
  font-family: sans-serif;
  .title {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 40px;
    color: #fff;
  }
  .text {
    font-family: "Arvo", serif;
    font-size: 15px;
    line-height: 26px;
    margin: 25px;
    color: #fff;
    font-size: 130%;
  }
`;

function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.bgImage}>
          <h1 className="title">RSVP</h1>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>

          <p className="text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
            ultrices <br />
            malesuada ante quis pharetra. Nullam non bibendum dolor. Ut vel
            turpis
          </p>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgImage: {
    background: `linear-gradient(0deg,rgba(125,50,210,0.5),rgba(200,170,110,0.5)),url(${Rs})`,
    height: 450,
    backgroundSize: "cover",
    backgroundPosition: "center",
    // padding: 50,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 3,
  },
};
export default Banner;
